// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './customers.es-AR.json';
import esCL from './customers.es-CL.json';
import esCO from './customers.es-CO.json';
import esMX from './customers.es-MX.json';
import ptBR from './customers.pt-BR.json';

const customersTranslations: DomainTranslations = {
  name: 'customers',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.CHILE]: esCL,
    [Locale.COLOMBIA]: esCO,
  },
};

export default customersTranslations;
